import { render } from "./ViewPaiementPage.vue?vue&type=template&id=532919d2&ts=true"
import script from "./ViewPaiementPage.vue?vue&type=script&lang=ts"
export * from "./ViewPaiementPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__